// import { CanActivateFn } from '@angular/router';

// export const authGuard: CanActivateFn = (route, state) => {
//   return true;
// };

import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { AuthService } from '../services/auth';
import { map, switchMap, take } from 'rxjs/operators';
import { AccountDisabledDialogComponent } from '../components/account-disabled-dialog.component';
import { MatDialog } from '@angular/material/dialog';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  constructor(private authService: AuthService, private router: Router,private dialog: MatDialog) {}

  // canActivate() {
  //   return this.authService.user$.pipe(
  //     take(1),
  //     map(user => {
  //       if (user) return true;
  //       this.router.navigate(['/login']);
  //       return false;
  //     })
  //   );
  // }

  // canActivate() {
  //   return this.authService.user$.pipe(
  //     take(1),
  //     map(user => {
  //       // No user → redirect to login
  //       if (!user) {
  //         this.router.navigate(['/login']);
  //         return false;
  //       }

  //       // Get custom claims from ID token
  //       const claims = (user as any).stsTokenManager?.accessToken 
  //         ? this.decodeToken((user as any).stsTokenManager.accessToken)
  //         : user.toJSON()?.stsTokenManager?.accessToken 
  //           ? this.decodeToken(user.toJSON().stsTokenManager.accessToken)
  //           : {};

  //       // Check if status is explicitly true
  //       const isActive = claims.status === true;

  //       if (!isActive) {
  //         // Optional: redirect to a "disabled" page
  //         this.router.navigate(['/account-disabled']);
  //         return false;
  //       }

  //       return true;
  //     })
  //   );
  // }

  canActivate() {
  return this.authService.user$.pipe(
    take(1),
    switchMap(async (user) => {
      if (!user) {
        this.router.navigate(['/login']);
        return false;
      }

      try {
        const tokenResult = await user.getIdTokenResult();
        // console.log(tokenResult.claims)
        const isActive = tokenResult.claims.status === true||tokenResult.claims.admin === true;

        // if (!isActive) {
        //   this.router.navigate(['/account-disabled']);
        // }
        if (!isActive) {
            // Show modal
            const dialogRef = this.dialog.open(AccountDisabledDialogComponent, {
              width: '400px',
              disableClose: true, // Prevent escape/click-out
              autoFocus: true
            });

            // Wait for user to click OK
            await dialogRef.afterClosed().toPromise();

            // Logout and redirect
            await this.authService.logout();
            this.router.navigate(['/login']);
            return false;
          }
        return isActive;
      } catch (error) {
        console.error('Token error:', error);
        this.router.navigate(['/login']);
        return false;
      }
    })
  );
}

  // Helper: Decode JWT token to get claims
  private decodeToken(token: string): any {
    try {
      const payload = token.split('.')[1];
      return JSON.parse(atob(payload));
    } catch (e) {
      console.error('Failed to decode token', e);
      return {};
    }
  }
}